import { render, staticRenderFns } from "./currency-select.vue?vue&type=template&id=4db48058"
import script from "./currency-select.vue?vue&type=script&lang=js"
export * from "./currency-select.vue?vue&type=script&lang=js"
import style0 from "./currency-select.vue?vue&type=style&index=0&id=4db48058&prod&lang=scss"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports